import { CallerType } from '@nimbus-library/features/shared/models/enum/caller-type.enum';
import { UserInteractionOutcome } from '@nimbus-library/features/agent-assistant/models/agent-assistant.model';
import { Icon } from '@nimbus-library/features/shared/resources/icons';
import { ChatMessageStatus } from '@nimbus-global/features/chat/models/chat-service.model';
import { IChatForm, IChatFormResolvedEvent } from '@nimbus-global/features/chat/models/chat-form.model';
import { MediaBlockReason, MessageDeliveryFailureReason } from '@nimbus-global/features/chat/models/chat-twilio.model';

export enum ChatServiceType {
  Whatsapp = 'Whatsapp',
  Sms = 'Sms',
  Rcs = 'Rcs',
}

export enum AuthorType {
  System = 'System',
  Customer = 'Customer',
  Agent = 'Agent',
  Companion = 'Companion',
}

export interface IChat {
  messages: IChatMessage[];
  error?: Error | null;
}

export enum ChatMediaKind {
  Image = 'Image',
  Audio = 'Audio',
  Video = 'Video',
  File = 'File',
}

export interface IChatMessageMedia {
  url: string;
  contentType: string | null;
  filename: string | null;
  size: number | null;
  kind: ChatMediaKind;
  blockReason: MediaBlockReason;
}

export interface IChatMessage {
  id: string;
  author: string;
  authorType: AuthorType;
  showAuthorInfo: boolean;
  content: string;
  contentIcon?: Icon;
  dateTime: string;
  index: number;
  status?: ChatMessageStatus;
  isFirstOfTheDay?: boolean;
  firstOfTheDayLabel?: string;
  hasBeenResent?: boolean;
  isMarkdown?: boolean;
  form?: IChatForm;
  media?: IChatMessageMedia[];
  failureReason?: MessageDeliveryFailureReason | null;
}

export interface IChatMessageFormResolvedEvent extends IChatFormResolvedEvent {
  message: IChatMessage;
}

export interface IChatInfo {
  type: ChatServiceType;
  conversationId: string;
  callerInfo: IChatCallerInfo;
  taskState?: UserInteractionOutcome;
}

export interface IChatCallerInfo {
  id: string;
  type: CallerType;
  displayName?: string;
}

export const CHAT_TYPING_CONTENT = 'typing';

export const INITIAL_MESSAGES_LIMIT_MAPPER: Record<ChatServiceType, number> = {
  [ChatServiceType.Whatsapp]: 100,
  [ChatServiceType.Sms]: 100,
  [ChatServiceType.Rcs]: 100,
};
